import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { filterUndefineds } from '@olivierpascal/helpers';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type {
  IApiGetIapPollsRequestBody,
  IApiGetIapPollsResponseBody,
} from '../IapPollsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseIapPollsQueryValues = {
  appId: string;
  body?: IApiGetIapPollsRequestBody;
};

export const iapPollsQueryKeyFactory: IQueryKeyFactory<
  IUseIapPollsQueryValues
> = (values) =>
  values && filterUndefineds(['iapPolls', values.appId, values.body]);

export const useIapPollsQuery = (
  values?: IUseIapPollsQueryValues,
  options?: UseQueryOptions<IApiGetIapPollsResponseBody, ApiError>,
): UseQueryResult<IApiGetIapPollsResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: iapPollsQueryKeyFactory(values),
    queryFn: values
      ? () => api.iapPolls.getAll(values.appId, values.body)
      : undefined,
    ...options,
  });
};
